'use strict';

exports.__esModule = true;

var _os = require('os');

exports.default = {
  pool: {
    size: (0, _os.cpus)().length
  }
};
//# sourceMappingURL=defaults.node.js.map



//////////////////
// WEBPACK FOOTER
// ./~/threads/lib/defaults.node.js
// module id = 35
// module chunks = 2